import { FETCH_HF4_HOMEWORK_SUCCESS } from './actions';
import { Map } from 'immutable';

export default function hf4Homework(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_HF4_HOMEWORK_SUCCESS: {
      if (! action.payload) return state.set(action.sessionId, null);
      return state.set(action.sessionId, action.payload);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/HF4Homework/reducer.js